(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-atrasados', {
            parent: 'app',
            url: '/entrega-dos-chamados',
            data: {
                authorities: ['ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_DESENVOLVEDOR'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados não entregues no prazo estimado'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-atrasados/chamados-atrasados.html',
                    controller: 'ChamadosAtrasadosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
